<template>
    <div class="footer">
        版权所有：北京联合信任技术服务有限公司 京ICP备13046264号-2
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    components: {},

    computed: {},

    created() {},

    mounted() {},

    methods: {},
};
</script>
<style lang='less' scoped>
.footer{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-top: 75px;
    padding-bottom: 48px;
}
</style>